import StyleSheet from 'react-native-media-query';

import themeStyle, { globalSpacing } from '../../Theme/styles';
import breakpoints from '../../Theme/styles/breakpoints';
import constants from '../../Config/constants';

export const { ids, styles } = StyleSheet.create({
  wrapper: {
    ...themeStyle.flex1,
    ...themeStyle.flexDirectionRow,
  },
  firstColumn: {
    ...themeStyle.pageHorizontalSpacing,
    ...themeStyle.pageVerticalSpacingMedium,
    flex: 1,
    display: 'none',
    height: constants.isWeb ? '75vh' : 0,
    // @ts-ignore: auto style is acceptable style on web
    overflow: 'auto',
    [`@media ${breakpoints.md}`]: {
      display: 'flex',
    },
    [`@media ${breakpoints.lg}`]: {
      flex: 1.25,
    },
  },
  gridContainer: {
    ...themeStyle.spacingRightMedium,
    // @ts-ignore: grid works on web
    display: 'grid',
    // @ts-ignore: gap works on web
    gap: globalSpacing * 2.1,
    // @ts-ignore: gridTemplateColumns works on web
    gridTemplateColumns: 'auto',
    [`@media ${breakpoints.xl}`]: {
      gridTemplateColumns: 'repeat(2, 1fr)',
    },
  },
  secondColumn: {
    flex: 1,
    [`@media ${breakpoints.md}`]: {
      ...themeStyle.spacingLeftMedium,
      borderRadius: 15,
      overflow: 'hidden',
    },
  },
  itemWrapperMobile: {
    position: 'absolute',
    bottom: 20,
    left: 0,
    right: 0,
    zIndex: 1,
    [`@media ${breakpoints.md}`]: {
      display: 'none',
    },
  },
});
